module.exports = "/assets/data/82eacfd94e0dac7930f223cce08e5e6b-CF39.data.json";